//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[1,"Edges",0,"ScCollector",0],[1,"EndAdjustment",0,"Expression",0],[1,"Faces",0,"ScCollector",0],[0,"FlatPatternCompensationAtEnd",1,0],[0,"FlatPatternCompensationAtStart",1,0],[0,"InferLength",1,0],[0,"Inset",1,0],[1,"Length",0,"Expression",0],[0,"LengthReference",1,0],[0,"Plane1",1,"Plane",0],[0,"Plane2",1,"Plane",0],[0,"ReverseDirection",1,0],[0,"ReverseTrimSide",1,0],[1,"StartAdjustment",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Features.SheetMetal.AdvancedFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.AdvancedFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.AdvancedFlangeBuilder.Types = Object.freeze({
    "ByValue" : "ByValue", "ToReference" : "ToReference"});

SPLM.Features.SheetMetal.AdvancedFlangeBuilder.LengthReferences = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside", "Web" : "Web", "Din6935" : "Din6935"});

SPLM.Features.SheetMetal.AdvancedFlangeBuilder.Insets = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside", "MaterialInsideOML" : "MaterialInsideOML"});

export default SPLM;